module.exports = __webpack_public_path__ + "media/images/delivary-icon-c6ae5dc8126b6ac2f3a3169e8a88ec8b.svg";